import React, { useContext } from "react";
import { makeStyles, Paper, Grid, Box } from "@material-ui/core";
import { Button } from "react-bootstrap";
import { CampContext } from "../../context/CampContext";
import { withRouter } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    paper: {
        boxSizing: "border-box",
        width: "100%",
        height: "100%",
        padding: theme.spacing(2),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        margin: "16px 0",
    },
    infoItem: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        ...theme.typography.h5,
    },
    flexCenter: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    flexCol: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    },
    btn: {
        width: "50%",
        margin: "10px 0",
    },
}));

//acomodar prop campania
const CampaingItem = (props) => {
    const classes = useStyles();

    const { history } = props; //react router

    const { state, setState } = useContext(CampContext);

    //console.log(props.campania )

    const campania = props.campania || {};

    const handleEdit = () => {
        if (props.parent === "params") {
            //si se esta creando nueva camp
            if (state.action === "new") {
                setState({
                    ...state,
                    form: true,
                    param: false,
                });
            }
            //si se esta editando camp ya creada
            if (state.action === "edit") {
                setState({
                    ...state,
                    search: false,
                    form: true,
                    param: false,
                });
            }
        } else if (props.parent === "search") {
            //cambia a editar cuando es seteada un campaña
            setState({
                ...state,
                action: "edit",
                currentCamp: { ...campania },
                search: false,
                form: false,
                param: true,
            });
        } else {
            alert("missing parent prop");
        }
    };

    const goToReportes = () => {
        history.push(`/reportes?hash=${campania.hash}`);
    };

    return (
        <Paper className={classes.paper} elevation={3}>
            <Grid item xs={12} sm={8} lg={6}>
                <div className={classes.infoItem}>
                    <span>Hash:</span>
                    <span>{campania.hash}</span>
                </div>

                <div className={classes.infoItem}>
                    <span>Nombre:</span>
                    <span>{campania.nombre}</span>
                </div>

                <div className={classes.infoItem}>
                    <span>Fecha Lanzamiento:</span>
                    <span>{campania.fechaLanzamiento}</span>
                </div>

                <div className={classes.infoItem}>
                    <span>Fecha Vencimiento:</span>
                    <span>{campania.fechaVencimiento}</span>
                </div>
            </Grid>

            <Grid item xs={12} sm={4} className={classes.flexCol}>
                <Button
                    className={classes.btn}
                    bsStyle="secondary"
                    onClick={handleEdit}
                >
                    Editar
                </Button>

                {props.parent === "search" && (
                    <Button
                        className={classes.btn}
                        bsStyle="primary"
                        onClick={goToReportes}
                    >
                        Reportes
                    </Button>
                )}
            </Grid>
        </Paper>
    );
};

export default withRouter(CampaingItem);



// WEBPACK FOOTER //
// ./src/components/campaing-items/CampaingItem.js